export const terms = {
  backToHome: "Terug naar home",
  title: "Algemene Voorwaarden",
  lastUpdated: "Laatst bijgewerkt: januari 2025",
  sections: {
    introduction: {
      title: "1. Bedrijfsidentificatie en Toepassingsgebied",
      paragraph1: "Deze algemene voorwaarden zijn van toepassing op alle verkopen en leveringen van bedrijfsgegevens door NovaVenture Group BV, gevestigd te Krommestraat 48, 2830 Blaasveld, België, met ondernemingsnummer 1006303437 en BTW-nummer BE1006303437.",
      paragraph2: "Door het plaatsen van een bestelling of het gebruik van onze diensten aanvaardt u deze algemene voorwaarden volledig en onvoorwaardelijk. Afwijkende voorwaarden van de koper zijn niet van toepassing, tenzij uitdrukkelijk schriftelijk aanvaard door NovaVenture Group BV."
    },
    services: {
      title: "2. Aard van de Diensten",
      intro: "NovaVenture Group BV verkoopt bedrijfsgegevens in Excel-formaat voor B2B-doeleinden. De geleverde gegevens omvatten uitsluitend:",
      items: [
        "Bedrijfsnamen van ondernemingen",
        "Vaste telefoonnummers (geen mobiele nummers)",
        "Volledige bedrijfsadressen",
        "BTW-nummers en ondernemingsnummers"
      ],
      outro: "Wij verwerken geen namen van natuurlijke personen, persoonlijke e-mailadressen of andere gevoelige persoonsgegevens. Alle gegevens zijn afkomstig uit publiek toegankelijke online bronnen waar ondernemingen hun informatie zelf openbaar hebben gepubliceerd."
    },
    usage: {
      title: "3. Toegestaan Gebruik",
      intro: "De geleverde bedrijfsgegevens mogen uitsluitend worden gebruikt voor:",
      items: [
        "Legitieme zakelijke prospectie conform de toepasselijke wetgeving",
        "B2B-marketing en commerciële contactname",
        "Marktonderzoek en business intelligence",
        "Interne bedrijfsdoeleinden binnen uw organisatie"
      ]
    },
    prohibited: {
      title: "4. Verboden Gebruik",
      intro: "Het is de koper uitdrukkelijk verboden om:",
      items: [
        "De gegevens te gebruiken voor spam of illegale marketingpraktijken",
        "De gegevens door te verkopen, te verhuren of te herdistribueren zonder voorafgaande schriftelijke toestemming van NovaVenture Group BV",
        "De gegevens te gebruiken voor doeleinden die in strijd zijn met de GDPR of andere toepasselijke wetgeving",
        "De gegevens te combineren met andere databanken zonder toestemming",
        "Ongewenste of agressieve contactname te plegen die de reputatie van NovaVenture Group BV kan schaden"
      ]
    },
    intellectualProperty: {
      title: "5. Intellectuele Eigendom",
      paragraph1: "Alle intellectuele eigendomsrechten met betrekking tot de databanken, de structuur, selectie en samenstelling van de gegevens blijven te allen tijde eigendom van NovaVenture Group BV.",
      paragraph2: "De koper verkrijgt uitsluitend een niet-exclusief, niet-overdraagbaar gebruiksrecht voor de aangekochte gegevens conform deze algemene voorwaarden. Reverse engineering, decompilatie of andere pogingen om de onderliggende structuur of methodologie te achterhalen zijn verboden."
    },
    disclaimer: {
      title: "6. Disclaimer en Geen Garanties",
      intro: "NovaVenture Group BV levert de bedrijfsgegevens 'as is' zonder enige garantie. Specifiek:",
      items: [
        "Wij garanderen niet de volledigheid van de gegevens",
        "Wij garanderen niet de juistheid of actualiteit van alle gegevens",
        "Bedrijfsgegevens kunnen verouderd zijn door bedrijfsverhuizingen, faillissementen of andere wijzigingen",
        "Wij zijn niet verantwoordelijk voor wijzigingen in gegevens na levering",
        "De koper is zelf verantwoordelijk voor verificatie van gegevens indien noodzakelijk"
      ],
      outro: "Hoewel wij streven naar maximale kwaliteit en actualiteit, kunnen wij geen absolute garanties geven over publiek beschikbare bedrijfsinformatie."
    },
    liability: {
      title: "7. Beperking van Aansprakelijkheid",
      intro: "De aansprakelijkheid van NovaVenture Group BV is beperkt als volgt:",
      items: [
        "Onze totale aansprakelijkheid is beperkt tot maximaal het factuurbedrag van de betreffende aankoop",
        "Wij zijn niet aansprakelijk voor indirecte schade, gevolgschade, gederfde winst of omzetverlies",
        "Wij zijn niet aansprakelijk voor schade voortvloeiend uit onjuist of onrechtmatig gebruik van de gegevens door de koper",
        "Wij zijn niet aansprakelijk voor claims van derden die voortvloeien uit het gebruik van de gegevens door de koper"
      ],
      outro: "Deze aansprakelijkheidsbeperking geldt niet in geval van opzet of grove nalatigheid van NovaVenture Group BV."
    },
    payment: {
      title: "8. Betaling en Facturering",
      intro: "Betalingsvoorwaarden:",
      items: [
        "Facturen zijn betaalbaar binnen 14 dagen na factuurdatum, tenzij anders overeengekomen",
        "Bij niet-tijdige betaling zijn wij gerechtigd een vertragingsrente van 10% per jaar in rekening te brengen",
        "Bij niet-betaling na aanmaning zijn alle openstaande facturen onmiddellijk opeisbaar",
        "Alle prijzen zijn exclusief BTW, tenzij uitdrukkelijk anders vermeld",
        "Incassokosten en gerechtelijke kosten komen ten laste van de koper bij wanbetaling"
      ]
    },
    termination: {
      title: "9. Beëindiging en Opschorting",
      intro: "NovaVenture Group BV behoudt zich het recht voor om:",
      items: [
        "De levering onmiddellijk te beëindigen bij schending van deze voorwaarden",
        "De toegang tot diensten op te schorten bij vermoeden van misbruik",
        "Lopende bestellingen te annuleren zonder terugbetaling bij verboden gebruik",
        "Juridische stappen te ondernemen bij ernstige schendingen"
      ],
      outro: "Bij beëindiging wegens wanprestatie van de koper blijft de betalingsverplichting volledig van kracht."
    },
    law: {
      title: "10. Toepasselijk Recht en Bevoegde Rechtbank",
      paragraph1: "Op deze algemene voorwaarden en alle overeenkomsten tussen NovaVenture Group BV en de koper is uitsluitend het Belgisch recht van toepassing.",
      paragraph2: "Alle geschillen die voortvloeien uit of verband houden met deze voorwaarden of de uitvoering ervan worden voorgelegd aan de bevoegde rechtbanken van het arrondissement Antwerpen, afdeling Mechelen, tenzij dwingend recht anders bepaalt."
    },
    dataProtection: {
      title: "11. Gegevensbescherming en GDPR-Naleving",
      paragraph1: "De koper erkent dat de aangekochte gegevens uitsluitend publiek beschikbare bedrijfsgegevens betreffen en geen persoonsgegevens in de zin van de GDPR.",
      paragraph2: "Indien de koper de gegevens gebruikt op een wijze die wel onder de GDPR valt, is de koper zelf verantwoordelijk voor naleving van alle toepasselijke wetgeving inzake gegevensbescherming. De koper vrijwaart NovaVenture Group BV voor alle claims die hieruit voortvloeien."
    },
    changes: {
      title: "12. Wijzigingen van de Voorwaarden",
      content: "NovaVenture Group BV behoudt zich het recht voor deze algemene voorwaarden te wijzigen. Wijzigingen worden van kracht na publicatie op onze website. Voor reeds gesloten overeenkomsten blijven de ten tijde van de bestelling geldende voorwaarden van toepassing."
    },
    severability: {
      title: "13. Deelbaarheid",
      content: "Indien een bepaling van deze algemene voorwaarden nietig of niet-afdwingbaar blijkt te zijn, blijven de overige bepalingen volledig van kracht. De nietige bepaling wordt geacht te zijn vervangen door een geldige bepaling die zoveel mogelijk aansluit bij de bedoeling van de oorspronkelijke bepaling."
    },
    contact: {
      title: "14. Contactgegevens",
      intro: "Voor vragen over deze algemene voorwaarden of onze diensten:",
      company: "NovaVenture Group BV",
      address: "Adres",
      phone: "Telefoon",
      email: "E-mail",
      businessNumber: "Ondernemingsnummer",
      vatNumber: "BTW-nummer"
    }
  },
  footer: {
    copyright: "© 2025 NovaVenture Group BV. Alle rechten voorbehouden."
  }
};